@if (loaded$ | async) {
    <form class="my-info-form" [formGroup]="myInfoForm">
        @if (enableNameEditing) {
            <div class="form-group">
                <div class="input-container">
                    <label class="input-label" for="firstName">{{
                        'label.common-terms.first.name' | translate
                    }}</label>
                    <input
                        class="input-field"
                        formControlName="firstName"
                        id="firstName"
                    />
                </div>
                <div class="input-container">
                    <label class="input-label" for="lastName">{{
                        'label.common-terms.last.name' | translate
                    }}</label>
                    <input
                        class="input-field"
                        formControlName="lastName"
                        id="lastName"
                    />
                </div>
            </div>
        }
        <div class="form-group">
            @if (enablePronounsEditing) {
                <div class="input-container">
                    <label class="input-label" for="pronouns">{{
                        'label.common-terms.pronouns' | translate
                    }}</label>
                    <tapestry-select
                        class="select-field"
                        id="pronouns"
                        [disabled]="!editable"
                        [options]="pronounOptions"
                        [selected]="selectedPronounOption"
                        (selectChanged)="updateSelectedPronoun($event)"
                    >
                    </tapestry-select>
                </div>
            }
            @if (enablePreferredNameEditing) {
                <div class="input-container">
                    <label class="input-label" for="preferredName">{{
                        'client-admin.organization-settings.personalization-settings.preferred-name-control.label'
                            | translate
                    }}</label>
                    <input
                        class="input-field"
                        formControlName="preferredName"
                        id="preferredName"
                    />
                </div>
            }
        </div>
    </form>
    <div class="save-btn-wrapper">
        <tapestry-button
            (click)="submitChanges()"
            [text]="'Save Changes'"
            class="my-info-form--save-button"
        ></tapestry-button>
    </div>
} @else {
    <tapestry-spinner [spinnerSize]="spinnerSize"></tapestry-spinner>
}
